import { DurationInputArg2 } from 'moment';

// all flags here, alphabetically sorted
export const ABSOLUTE_TIMEOUT = 'absolute-timeout';
export const APP_VERSION = 'app-version';
export const ASK = 'ask';
export const AUTOMATIONS_IN_CARD_FORM = 'automations-in-card-form';
export const BACK_BUTTON_HISTORY = 'back-button-history';
export const BATCH_UPLOAD_USERS = 'batch-upload-users';
export const BUILDER = 'builder';
export const BUILDER_CREATE_EXTERNAL_FORM_LINK_ACTION = 'builder-create-external-form-link-action';
export const BUILDER_RENAME_INTERNAL_FORMS = 'builder-rename-internal-forms';
export const BUILDER_VIEW_TEMPLATES = 'builder-view-templates';
export const CHECKLIST_IN_LIST_VIEW = 'checklist-in-list-view';
export const COMPONENT_DELETE = 'component-delete';
export const CSV_BULK_IMPORT = 'csv-bulk-import';
export const DATA_FRESHNESS = 'data-freshness';
export const DATE_RANGE_COMPONENT = 'date-range-component';
export const DELETE_WORKSPACE_SECTION = 'delete-workspace-section';
export const DEVELOPER_TOOLS = 'developer-tools';
export const DUPLICATE_WORKSPACE_SECTION = 'duplicate-workspace-section';
export const EDITABLE_VIEW_TYPE = 'editable-view-type';
export const EXPANDED_SUBFORM_FIELDS = 'expanded-subform-fields';
export const INACTIVITY_TIMEOUT = 'inactivity-timeout';
export const LAYOUT_EDITOR = 'layout-editor';
export const MULTIPLE_FILTER_GROUPS = 'multi-filter-groups';
export const PAYWALL_EXPERIMENT = 'paywall-experiment';
export const PERMISSIONS_REFETCH_TIMER = 'permissions-refetch-timer';
export const PM60 = 'endless-preventative-management';
export const REPORTING_UI = 'reporting-ui';
export const REQUIRED_FIELDS_IN_VIEW_TEMPLATE_BUILDER = 'required-fields-in-view-template-builder';
export const REQUIRED_SUBFORM_FIELDS = 'required-subform-fields';
export const SECONDARY_LOOKUP_FIELDS = 'secondary-lookup-fields';
export const SUBFORM_GENERATION = 'subform-gen';
export const TIME_TRACKER_COMPONENT_GEOLOCATION = 'time-tracker-component-geolocation';
export const USER_GROUPS = 'user-groups';
export const WEB_VIEW_SELECTOR = 'web-view-selector';
export const WORKFLOW_SHARING = 'workflow-sharing';
export const WORKFLOW_SHARING_CARD_DATA = 'workflow-sharing-card-data';

export interface AppVersionFlag {
  version: string;
  frequency: DurationInputArg2; // e.g. 'day', 'week', etc.
}

const appVersionFlagDefault: AppVersionFlag = {
  version: import.meta.env.VITE_VERSION,
  frequency: 'week',
};

// set default flag state here, alphabetically sorted
export const defaultFlags = {
  [ABSOLUTE_TIMEOUT]: 0,
  [APP_VERSION]: appVersionFlagDefault,
  [ASK]: false,
  [AUTOMATIONS_IN_CARD_FORM]: false,
  [BACK_BUTTON_HISTORY]: false,
  [BATCH_UPLOAD_USERS]: false,
  [BUILDER]: false,
  [BUILDER_CREATE_EXTERNAL_FORM_LINK_ACTION]: false,
  [BUILDER_RENAME_INTERNAL_FORMS]: false,
  [BUILDER_VIEW_TEMPLATES]: false,
  [CHECKLIST_IN_LIST_VIEW]: false,
  [COMPONENT_DELETE]: false,
  [CSV_BULK_IMPORT]: false,
  [DATA_FRESHNESS]: {
    enabled: false,
    logPrefix: '',
    maxRetries: 1,
    refetchThrottleMs: 1000,
    sleepDetectorIntervalMs: 1000,
    sleepDetectorTriggerRefetchMs: 1000,
  },
  [DATE_RANGE_COMPONENT]: false,
  [DELETE_WORKSPACE_SECTION]: false,
  [DEVELOPER_TOOLS]: false,
  [DUPLICATE_WORKSPACE_SECTION]: false,
  [EDITABLE_VIEW_TYPE]: false,
  [EXPANDED_SUBFORM_FIELDS]: false,
  [INACTIVITY_TIMEOUT]: 0,
  [LAYOUT_EDITOR]: false,
  [MULTIPLE_FILTER_GROUPS]: false,
  [PAYWALL_EXPERIMENT]: '', // redacted or banner
  [PERMISSIONS_REFETCH_TIMER]: 0,
  [PM60]: false,
  [REPORTING_UI]: false,
  [REQUIRED_FIELDS_IN_VIEW_TEMPLATE_BUILDER]: false,
  [REQUIRED_SUBFORM_FIELDS]: false,
  [SECONDARY_LOOKUP_FIELDS]: false,
  [SUBFORM_GENERATION]: false,
  [TIME_TRACKER_COMPONENT_GEOLOCATION]: false,
  [USER_GROUPS]: false,
  [WEB_VIEW_SELECTOR]: false,
  [WORKFLOW_SHARING]: false,
  [WORKFLOW_SHARING_CARD_DATA]: false,
};

export type Flags = typeof defaultFlags;
export type FlagName = keyof Flags;
